// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // api: "http://localhost:47634/pharmacy/",
  // notifyUrl: "http://localhost:47634/",
  // uiUrl: "http://localhost:4200",

  // api: "http://13.71.22.234:2022/API/pharmacy/",
  // notifyUrl: "http://13.71.22.234:2022/API/",
  // uiUrl: "http://13.71.22.234:2022",

  // api: "https://staging.hilltoppharmacyltd.com/API/pharmacy/",
  // notifyUrl: "https://staging.hilltoppharmacyltd.com/API/",
  // uiUrl: "https://staging.hilltoppharmacyltd.com",

  // api: "http://43.231.124.151:1202/API/pharmacy/",
  // notifyUrl: "http://43.231.124.151:1202/API/",
  // uiUrl: "http://43.231.124.151:1202",

  api: "https://app.hilltoppharmacyltd.com/API/pharmacy/",
  notifyUrl: "https://app.hilltoppharmacyltd.com/API/",
  uiUrl: "https://app.hilltoppharmacyltd.com",

  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
